import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordComponent } from './forgot-password.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ForgotPasswordComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    RouterModule,
  ]
})
export class ForgotPasswordModule { }
